import { FC } from "react";

import { List } from "antd";

import { useAppSelector } from "@/hooks/redux";

const ErrorLogs: FC = () => {
  const errors = useAppSelector(
    (state) => state.currentDataReducer.loggedErrors
  );

  return (
    <List
      size="small"
      bordered
      dataSource={errors.map((error) => ({ message: error, key: error }))}
      renderItem={(error) => <List.Item>{error.message}</List.Item>}
    />
  );
};

export default ErrorLogs;
